module.exports = __webpack_public_path__ + "static/media/24UHCHR25.c7afe8ce.jpg";